// extracted by mini-css-extract-plugin
export default {"root":"JKP9o__root","disableCtrls":"guDsk__disableCtrls","video":"Xr_1Q__video","rtlSubtitles":"xuTJ5__rtlSubtitles","subtitlesActive":"NVnoN__subtitlesActive"};